module.exports = __webpack_public_path__ + "static/media/Google_Play_Store_badge_EN.17615144.svg";